import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DateBox from 'devextreme-react/date-box';
import SelectBox from 'devextreme-react/select-box';
import { MobileCardList } from '../../components/mobile/MobileCardList';
import { io } from 'socket.io-client';
import { nameserver } from '../../config/nameServer';
type TuanTraRow = {
  ID: number;
  TEN_THIET_BI: string;
  TEN_BO_PHAN: string;
  NOI_DUNG_KIEM_TRA: string;
  TIEU_CHUAN?: string;
  TEN_CUM?: string;
  KET_QUA?: string;
};
// const TEST_TIME = new Date('2026-05-08T05:01:00');
const getCurrentCa = () => {
  //   const now = TEST_TIME;
  // const hour = now.getHours();
  const hour = new Date().getHours();

  if (hour >= 6 && hour < 14) {
    return 1;
  }

  if (hour >= 14 && hour < 22) {
    return 2;
  }

  return 3;
};

const getDefaultDate = () => {
  // const now = new Date(TEST_TIME);
  // const hour = now.getHours();
  const now = new Date();
  const hour = now.getHours();

  // 0h -> 5h59 thì lấy ngày hôm trước
  if (hour < 6) {
    now.setDate(now.getDate() - 1);
  }

  return now;
};
export const TuanTraMobile = () => {
  const [device, setDevice] = useState<any[]>([]);
  const [cum, setCum] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [selectedDate, setSelectedDate] = useState(getDefaultDate());
  const [selectedDevice, setSelectedDevice] = useState<string | null>(null);
  const [selectedCa, setSelectedCa] = useState(getCurrentCa());
  const [selectedCap, setSelectedCap] = useState(1);
  const [selectedCum, setSelectedCum] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string>('Tất cả');
  const [isLoaded, setIsLoaded] = useState(false);

  const [searchDevice, setSearchDevice] = useState<string | null>(null);
  const [searchCum, setSearchCum] = useState<string | null>(null);
  const [searchCa, setSearchCa] = useState<number | null>(null);
  const [searchCap, setSearchCap] = useState<number | null>(null);
  const [searchStatus, setSearchStatus] = useState<string>('Tất cả');
  const [loading, setLoading] = useState(false);
  const caList = [
    { id: 1, name: 'Ca 1' },
    { id: 2, name: 'Ca 2' },
    { id: 3, name: 'Ca 3' },
  ];
  const capTuanTraList = [
    { id: 1, name: 'Cấp 1' },
    { id: 2, name: 'Cấp 2' },
    { id: 3, name: 'Cấp 3' },
  ];

  const statusList = ['Tất cả', 'OK', 'Not OK', 'Chưa kiểm tra'];
  const loadCum = async (date = selectedDate) => {
    // const ngay = new Date(date).toISOString().split('T')[0];
    const userId = localStorage.getItem('userId');
    console.log(userId);
    // console.log(ngay);

    const res = await axios.get(`${nameserver}/api/getCum`);
    console.log('data:', res.data);

    setCum(res.data);
  };
  const loadDevice = async (date = selectedDate) => {
    // const ngay = new Date(date).toISOString().split('T')[0];
    const userId = localStorage.getItem('userId');
    console.log(userId);
    // console.log(ngay);

    const res = await axios.get(`${nameserver}/api/getThietBi`);
    console.log('data:', res.data);

    setDevice(res.data);
  };

  useEffect(() => {
    loadCum();
    loadDevice();
  }, []);
  const loadData = async () => {
    if (!selectedDate || !selectedCa || !selectedCap) {
      alert('Vui lòng chọn đầy đủ thông tin');
      return;
    }
    setLoading(true);
    const d = new Date(selectedDate);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    const ngay = `${year}-${month}-${day}`;

    // const cap = localStorage.getItem('cap');

    const res = await axios.get(
      `${nameserver}/api/tuantrathietbi_mobile?ngay=${ngay}`
    );
    setLoading(false);
    setSearchCum(selectedCum);
    setSearchDevice(selectedDevice);
    setSearchCa(selectedCa);
    setSearchCap(selectedCap);
    setSearchStatus(selectedStatus);
    setData(res.data);
    setIsLoaded(true);
  };

  // useEffect(() => {
  //   loadData(selectedDate);
  // }, [selectedDate, selectedCa]);

  useEffect(() => {
    const socket = io(`${nameserver}`);

    socket.on('connect', () => {
      console.log('Mobile connected');
    });

    socket.on('tuantra_updated', (updated) => {
  setData(prev =>
    prev.map(x => x.ID === updated.ID ? updated : x)
  );
});

    return () => {
      socket.disconnect(); // ✅ cleanup đúng
    };
  }, []);

  const cumList = [
    'Tất cả',
    ...cum.map((x) => x.TEN_CUM).filter((v, i, self) => self.indexOf(v) === i),
  ];
  const deviceList = [
    'Tất cả',
    ...device
      .filter((x) => {
        if (!selectedCum || selectedCum === 'Tất cả') {
          return true;
        }

        return x.TEN_CUM === selectedCum;
      })
      .map((x) => x.TEN_THIET_BI)
      .filter((v, i, self) => self.indexOf(v) === i),
  ];
  const filteredData = data.filter((x) => {
    // cụm
    if (searchCum && searchCum !== 'Tất cả' && x.TEN_CUM !== searchCum) {
      return false;
    }

    // thiết bị
    if (
      searchDevice &&
      searchDevice !== 'Tất cả' &&
      x.TEN_THIET_BI !== searchDevice
    ) {
      return false;
    }

    // ca
    if (searchCa && x.CA !== searchCa) {
      return false;
    }

    // cấp
    if (searchCap && x.CAP !== searchCap) {
      return false;
    }

    // trạng thái
    if (searchStatus && searchStatus !== 'Tất cả') {
      if (searchStatus === 'Chưa kiểm tra') {
        if (x.KET_QUA) {
          return false;
        }
      } else {
        if (x.KET_QUA !== searchStatus) {
          return false;
        }
      }
    }

    return true;
  });

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        marginBottom: '50vh',
        overflowY: 'auto',
        paddingBottom: 300,
        background: '#f5f5f5',
      }}
    >
      <div style={{ margin: '12px 0' }}>
        <div style={{ marginBottom: 6, fontWeight: 600 }}>Chọn ngày</div>

        <DateBox
          type='date'
          value={selectedDate}
          displayFormat='dd/MM/yyyy'
          onValueChanged={(e) => {
            setSelectedDate(e.value);
            // loadDevice(e.value);
            // loadData(e.value);
          }}
          width='100%'
          inputAttr={{
            style: {
              fontSize: '16px',
            },
          }}
        />
      </div>
      <div style={{ margin: '12px 0' }}>
        <div style={{ marginBottom: 6, fontWeight: 600 }}>Trạng thái</div>

        <SelectBox
          dataSource={statusList}
          value={selectedStatus}
          onValueChanged={(e) => setSelectedStatus(e.value)}
          width='100%'
          stylingMode='outlined'
          placeholder='Chọn trạng thái'
          inputAttr={{
            style: {
              fontSize: '16px',
            },
          }}
        />
      </div>
      <div style={{ margin: '12px 0' }}>
        <div style={{ marginBottom: 6, fontWeight: 600 }}>Chọn Cụm</div>

        <SelectBox
          dataSource={cumList}
          value={selectedCum}
          onValueChanged={(e) => {
            setSelectedCum(e.value);
            setSelectedDevice(null); // reset thiết bị
          }}
          width='100%'
          stylingMode='outlined'
          placeholder='Chọn cụm'
          inputAttr={{
            style: {
              fontSize: '16px',
            },
          }}
        />
      </div>
      <div style={{ margin: '12px 0' }}>
        <div style={{ marginBottom: 6, fontWeight: 600 }}>Chọn thiết bị</div>

        <SelectBox
          dataSource={deviceList}
          value={selectedDevice}
          onValueChanged={(e) => setSelectedDevice(e.value)}
          width='100%'
          stylingMode='outlined'
          placeholder='Chọn thiết bị'
          searchEnabled={true} // ✅ bật tìm kiếm
          searchExpr={(item) => item} // item ở đây là chuỗi trong deviceList
          inputAttr={{
            style: {
              fontSize: '16px',
            },
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          gap: 12,
          margin: '12px 0',
        }}
      >
        {/* CA */}
        <div style={{ flex: 1 }}>
          <div
            style={{
              marginBottom: 6,
              fontWeight: 600,
            }}
          >
            Chọn CA
          </div>

          <SelectBox
            stylingMode='outlined'
            dataSource={caList}
            displayExpr='name'
            valueExpr='id'
            placeholder='Chọn ca'
            value={selectedCa}
            onValueChanged={(e) => setSelectedCa(e.value)}
            width='100%'
            inputAttr={{
              style: {
                fontSize: '16px',
              },
            }}
          />
        </div>

        {/* CẤP */}
        <div style={{ flex: 1 }}>
          <div
            style={{
              marginBottom: 6,
              fontWeight: 600,
            }}
          >
            Chọn Cấp
          </div>

          <SelectBox
            stylingMode='outlined'
            dataSource={capTuanTraList}
            displayExpr='name'
            valueExpr='id'
            placeholder='Chọn cấp'
            value={selectedCap}
            onValueChanged={(e) => setSelectedCap(e.value)}
            width='100%'
            inputAttr={{
              style: {
                fontSize: '16px',
              },
            }}
          />
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
  <button
    onClick={loadData}
    disabled={loading}
    style={{
      width: '100%',
      marginBottom: '20px',
      padding: '10px',
      border: 'none',
      borderRadius: 14,
      background: loading
        ? '#94a3b8'
        : 'linear-gradient(135deg,#2563eb,#1d4ed8)',
      color: '#fff',
      fontSize: 16,
      fontWeight: 700,
      cursor: loading ? 'not-allowed' : 'pointer',
      boxShadow: loading
        ? 'none'
        : '0 4px 10px rgba(37,99,235,0.25)',
      transition: '0.2s',
    }}
  >
    {loading ? '⏳ Đang tải dữ liệu...' : '🔍 Tra cứu tuần tra'}
  </button>
</div>
      {isLoaded && (
        <MobileCardList
          data={filteredData}
          selectedCa={selectedCa}
          selectedDate={selectedDate}
          loadData={() => loadData()}
          setData={setData}
        />
      )}
    </div>
  );
};
